const slots = document.querySelectorAll('[data-skeepers-slot]');

if (slots.length) {
  const templates = new Map();
  slots.forEach((slot) => {
    if (slot.firstElementChild) templates.set(slot, slot.firstElementChild.cloneNode(true));
  });

  document.addEventListener('variantChangeEnd', (event) => {
    const sku = event.target.currentVariant?.sku;
    const handle = event.target.getAttribute('data-product-handle');
    if (!sku) return;

    slots.forEach((slot) => {
      if (slot.dataset.skeepersHandle !== handle) return;

      const current = slot.firstElementChild;
      if (current) {
        current.setAttribute('data-product-id', sku);
        return;
      }

      const template = templates.get(slot);
      if (!template) return;
      const fresh = template.cloneNode(true);
      fresh.setAttribute('data-product-id', sku);
      slot.appendChild(fresh);
    });
  });
}
